module.exports = __webpack_public_path__ + "static/media/lais-juliana.d96d6bb1.png";